import { createApp, h } from 'vue';
import MessageBoxComponent from './MessageBox.vue';
import { loginSDK } from '../../../..';
export interface MessageBoxOptions {
  email: string;
}

export function openMessageBox(
    options: MessageBoxOptions
): Promise<string | undefined> {
    const div = document.createElement('div');
    document.body.appendChild(div);

    const promise = new Promise<string | undefined>((resolve) => {
        const unmountApp = () => {
            document.body.removeChild(div);
        };

        const i18n = loginSDK.getI18n();

        const app = createApp({
            render() {
                return h(MessageBoxComponent, {
                    ...options,
                    callback: (input: string) => {
                        resolve(input);
                        app.unmount();

                        unmountApp();
                    },
                    cancelCallback: () => {
                        resolve(undefined);
                        app.unmount();
                        unmountApp();
                    },
                });
            },
        });
        i18n && app.use(i18n);
        app.mount(div);
    });

    return promise;
}
